import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { ComingSoon, ValueListTable } from '@config/components';
import { useConfigContext } from '@config/context';

export const ValueListsPage = (): ReactElement => {
  const { t } = useTranslation();
  const { getValueLists } = useConfigContext();

  if (!getValueLists) return <ComingSoon sectionKey="valueLists" />;

  return (
    <Page>
      <Page.Title>{t('config.sections.valueLists')}</Page.Title>
      <Page.Content fill>
        <ValueListTable kind="fixed" />
      </Page.Content>
    </Page>
  );
};
